"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageBounding = void 0;
const Snap = __importStar(require("snapsvg-cjs"));
const ClientSVGSetting_1 = require("./ClientSVGSetting");
const SVG_1 = require("./SVG");
class ImageBounding {
    static isValidViewBox(input) {
        const svg = typeof input === 'string' ? SVG_1.SVG.parseFromString(input) : input;
        if (svg) {
            const viewBox = ImageBounding.getViewbox(svg);
            if (viewBox) {
                return (viewBox[0] === ClientSVGSetting_1.ClientSVGSetting.viewBox[0] &&
                    viewBox[1] === ClientSVGSetting_1.ClientSVGSetting.viewBox[1] &&
                    viewBox[2] === ClientSVGSetting_1.ClientSVGSetting.viewBox[2] &&
                    viewBox[3] === ClientSVGSetting_1.ClientSVGSetting.viewBox[3]);
            }
        }
        return false;
    }
    static getSVGElementsBounding(input) {
        const svg = typeof input === 'string' ? SVG_1.SVG.parseFromString(input) : input;
        if (svg) {
            return ImageBounding.getBounding(svg);
        }
    }
    /**
     * Return SVG viewBox
     * If it is not present, calculate it based on elements
     *
     * @static
     * @param {SVGElement} svg
     * @returns {[number, number, number, number]}
     */
    static getViewbox(svg) {
        // Check viexBox is setted
        const viewBox = svg.getAttribute('viewBox');
        if (viewBox) {
            return viewBox.split(' ').map(e => parseFloat(e));
        }
        // Check width and height if viewBox is not setted
        const width = svg.getAttribute('width');
        const height = svg.getAttribute('height');
        if (width && height) {
            return [0, 0, parseFloat(width), parseFloat(height)];
        }
        // Calculate dimension by elements
        svg = svg.cloneNode(true);
        const elements = Array.from(svg.querySelectorAll('rect, circle, ellipse, line, polyline, polygon, path'));
        const paths = [].concat.apply([], elements.map(e => ImageBounding.elementToPath(e)));
        if (paths.length > 0) {
            let width = 0, height = 0;
            for (let i = 0, len = paths.length; i < len; i++) {
                const box = ImageBounding.getBBox(paths[i]);
                box.width += box.x;
                box.height += box.y;
                if (box.width > width)
                    width = box.width;
                if (box.height > height)
                    height = box.height;
            }
            return [0, 0, width, height];
        }
        return null;
    }
    static getBounding(svg) {
        // Calculate dimension by elements
        svg = svg.cloneNode(true);
        const elements = Array.from(svg.querySelectorAll('rect, circle, ellipse, line, polyline, polygon, path'));
        const paths = [].concat.apply([], elements.map(e => ImageBounding.elementToPath(e)));
        if (paths.length > 0) {
            let minX = Number.MAX_SAFE_INTEGER, maxX = Number.MIN_SAFE_INTEGER, minY = Number.MAX_SAFE_INTEGER, maxY = Number.MIN_SAFE_INTEGER;
            for (let i = 0, len = paths.length; i < len; i++) {
                const box = ImageBounding.getBBox(paths[i]);
                if (box.width + box.x > maxX)
                    maxX = box.width + box.x;
                if (box.height + box.y > maxY)
                    maxY = box.height + box.y;
                if (box.x < minX)
                    minX = box.x;
                if (box.y < minY)
                    minY = box.y;
            }
            return [minX, minY, maxX - minX, maxY - minY];
        }
    }
    static getBBox(path) {
        let minX = Number.MAX_SAFE_INTEGER, maxX = Number.MIN_SAFE_INTEGER, minY = Number.MAX_SAFE_INTEGER, maxY = Number.MIN_SAFE_INTEGER;
        for (let i = 0, len = path.getTotalLength(), offset = len / 300; i < len; i += offset) {
            const { x, y } = path.getPointAtLength(i);
            if (x < minX)
                minX = x;
            if (x > maxX)
                maxX = x;
            if (y < minY)
                minY = y;
            if (y > maxY)
                maxY = y;
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY,
        };
    }
    /**
     * Convert SVG Element to Path
     *
     * @static
     * @param {SVGElement} element
     * @returns {Array<SVGPathElement>}
     */
    static elementToPath(element) {
        const transform = element.getAttribute('transform') || '';
        const fill = element.getAttribute('fill');
        const stroke = element.getAttribute('stroke');
        const lineWidth = element.getAttribute('lineWidth');
        if (element.nodeName == 'path') {
            // Separate multiple path
            const d = element.getAttribute('d') || '';
            const result = Snap.path
                .toAbsolute(d)
                .map((e) => `${e.shift()}${e.join(',')}`)
                .join(' ')
                .split('M')
                .filter((e) => e.length > 0)
                .map((e) => 'M' + e);
            return result.map((d) => {
                const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                path.setAttribute('d', d);
                path.setAttribute('transform', transform);
                fill && path.setAttribute('fill', fill);
                stroke && path.setAttribute('stroke', stroke);
                lineWidth && path.setAttribute('lineWidth', lineWidth);
                return path;
            });
        }
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        const nodeName = element.nodeName;
        if (['rect', 'ellipse', 'circle', 'line', 'polyline', 'polygon'].includes(nodeName)) {
            path.setAttribute('d', ImageBounding.CONVERSION[nodeName](element));
            path.setAttribute('transform', transform);
            fill && path.setAttribute('fill', fill);
            stroke && path.setAttribute('stroke', stroke);
            lineWidth && path.setAttribute('lineWidth', lineWidth);
            return [path];
        }
        else {
            console.warn(`[SVGImport] | Cannot convert ${nodeName} to path`);
            return [];
        }
    }
    /**
     * Get percentage to number
     *
     * @private
     * @static
     * @param {(number | string)} val
     * @param {number} base
     * @returns {number}
     */
    static fromPercentage(val, base) {
        return /%$/.test(val + '') ? (parseFloat((val + '').replace('%', '')) * 100) / base : +val;
    }
    /**
     * Separate multiple array
     *
     * @private
     * @static
     * @param {(Array<string | number>)} arr
     * @param {number} [size=2]
     * @returns {(Array<Array<string | number>>)}
     */
    static chunk(arr, size = 2) {
        const results = [];
        while (arr.length > 0)
            results.push(arr.splice(0, size));
        return results;
    }
}
exports.ImageBounding = ImageBounding;
/**
 * Convert Elements to path
 *
 * @private
 * @static
 * @type {ISVGElementConversion}
 */
ImageBounding.CONVERSION = {
    rect: (rect) => {
        const width = parseFloat(rect.getAttribute('width') || '0');
        const height = parseFloat(rect.getAttribute('height') || '0');
        const x = parseFloat(rect.getAttribute('x') || '0');
        const y = parseFloat(rect.getAttribute('y') || '0');
        let rx = rect.getAttribute('rx') || 'auto';
        let ry = rect.getAttribute('ry') || 'auto';
        if (rx === 'auto' && ry === 'auto')
            rx = ry = 0;
        else if (rx !== 'auto' && ry === 'auto')
            rx = ry = ImageBounding.fromPercentage(rx, width);
        else if (ry !== 'auto' && rx === 'auto')
            ry = rx = ImageBounding.fromPercentage(ry, height);
        else {
            rx = ImageBounding.fromPercentage(rx, width);
            ry = ImageBounding.fromPercentage(ry, height);
        }
        if (rx > width / 2)
            rx = width / 2;
        if (ry > height / 2)
            ry = height / 2;
        const hasCurves = rx > 0 && ry > 0;
        return [
            `M${x + rx} ${y}`,
            `H${x + width - rx}`,
            ...(hasCurves ? [`A${rx} ${ry} 0 0 1 ${x + width} ${y + ry}`] : []),
            `V${y + height - ry}`,
            ...(hasCurves ? [`A${rx} ${ry} 0 0 1 ${x + width - rx} ${y + height}`] : []),
            `H${x + rx}`,
            ...(hasCurves ? [`A${rx} ${ry} 0 0 1 ${x} ${y + height - ry}`] : []),
            `V${y + ry}`,
            ...(hasCurves ? [`A${rx} ${ry} 0 0 1 ${x + rx} ${y}`] : []),
            'Z',
        ].join(' ');
    },
    ellipse: (ellipse) => {
        var _a, _b, _c, _d;
        const cx = parseFloat(ellipse.getAttribute('cx') || '0');
        const cy = parseFloat(ellipse.getAttribute('cy') || '0');
        const rx = parseFloat((_b = (_a = ellipse.getAttribute('rx')) !== null && _a !== void 0 ? _a : ellipse.getAttribute('r')) !== null && _b !== void 0 ? _b : '0');
        const ry = parseFloat((_d = (_c = ellipse.getAttribute('ry')) !== null && _c !== void 0 ? _c : ellipse.getAttribute('r')) !== null && _d !== void 0 ? _d : '0');
        return [
            `M${cx + rx} ${cy}`,
            `A${rx} ${ry} 0 0 1 ${cx} ${cy + ry}`,
            `A${rx} ${ry} 0 0 1 ${cx - rx} ${cy}`,
            `A${rx} ${ry} 0 0 1 ${cx + rx} ${cy}`,
            'Z',
        ].join(' ');
    },
    circle: (circle) => ImageBounding.CONVERSION.ellipse(circle),
    line: (line) => `M${line.getAttribute('x1') || '0'} ${line.getAttribute('y1') || '0'} L${line.getAttribute('x2') || '0'} ${line.getAttribute('y2') || '0'}`,
    polyline: (polyline) => {
        const points = polyline.getAttribute('points') || '';
        const pointsArray = points
            .trim()
            .replace(/  +/g, ' ')
            .split(' ')
            .reduce((arr, point) => [...arr, ...(point.includes(',') ? point.split(',') : [point])], []);
        const pairs = ImageBounding.chunk(pointsArray, 2);
        return pairs.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x} ${y}`).join(' ');
    },
    polygon: (polygon) => ImageBounding.CONVERSION.polyline(polygon) + ' Z',
    path: (path) => path.getAttribute('d') + '',
};
